// UserInfo.js
import React, { useState } from 'react';
import { updateApikey } from '../../services/auth';
import Modal from '../common/Modal';
import theme from '../../theme';

function UserInfo({ user }) {
  const [apiKey, setApiKey] = useState(user.api_key);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleRegenerate = async () => {
    setLoading(true);
    setError(null);
    try {
      const newApiKey = await updateApikey(user.name, user.email);

      if (newApiKey) {
        setApiKey(newApiKey);
      } else {
        setError('Failed to update API key');
      }
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const confirmRefreshToken = () => {
    handleRegenerate();
    setIsModalOpen(false);
  }

  return (
    <div className={`${theme.cardBg} ${theme.cardBorder} ${theme.cardRound} p-6 ${theme.cardShadow}`}>
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className='text-center w-56'>
          <div className="mx-auto my-4 w-48">
            <h3 className={`text-lg font-black ${theme.textPrimary} mb-2`}>Confirm API token refresh</h3>
            <p className={`text-sm font-medium ${theme.textSecondary} mb-4`}>This action is irreversible</p>
            <button onClick={() => confirmRefreshToken()} className={`w-full py-2 rounded-xl text-sm font-semibold ${theme.btnDanger}`}>
              Confirm
            </button>
          </div>
        </div>
      </Modal>
      <h2 className={`text-xl font-bold mb-4 ${theme.textPrimary}`}>User Information</h2>
      <div className="space-y-2">
        <p className="text-sm">
          <span className={`font-semibold ${theme.textSecondary}`}>Name:</span>{' '}
          <span className={theme.textPrimary}>{user.name}</span>
        </p>
        <p className="text-sm">
          <span className={`font-semibold ${theme.textSecondary}`}>Email:</span>{' '}
          <span className={theme.textPrimary}>{user.email}</span>
        </p>
        <p className="text-sm">
          <span className={`font-semibold ${theme.textSecondary}`}>API token:</span>{' '}
          <span className={`${theme.textPrimary} break-all`}>{apiKey}</span>
        </p>
        <button
          onClick={() => setIsModalOpen(true)}
          disabled={loading}
          className={`mt-2 px-4 py-2 rounded-xl text-sm font-semibold ${theme.btnDanger} disabled:opacity-50`}
        >
          {loading ? 'Refreshing...' : 'Refresh API token'}
        </button>
        {error && <p className="text-red-500 text-sm">{error}</p>}
      </div>
    </div>
  );
}

export default UserInfo;